import config from "config";
export type MenuItemType = {
  key: string;
  label: string;
  isTitle?: boolean;
  icon?: string;
  url?: string;
  badge?: {
    variant: string;
    text: string;
  };
  parentKey?: string;
  target?: string;
  children?: MenuItemType[];
};

const getDisabledMenuItem = (disablemenu: string) => {
  const disableMenu = disablemenu.split(",");
  return disableMenu;
};
const filterMenuItem = (items: MenuItemType[], disablemenu: string) => {
  const disableMenuItem = getDisabledMenuItem(disablemenu);
  return items
    .filter(item => !disableMenuItem.includes(item.key))
    .map(item => {
      if (item.children) {
        item.children = filterMenuItem(item.children, disablemenu);
      }
      return item;
    });
};

const MENU_ITEMS: MenuItemType[] = filterMenuItem(
  [
    {
      key: "ds-analytics",
      label: "Dashboard",
      url: "/dashboard/my",
      icon: "uil-home-alt"
    },
    { key: "navigation", label: "Setup", isTitle: true },
    {
      key: "master",
      label: "Masters",
      isTitle: false,
      icon: "uil-box",
      // badge: { variant: 'success', text: '4' },
      children: [
        {
          key: "User",
          label: "User Management",
          url: "/master/users",
          parentKey: "master"
        },
        {
          key: "Role",
          label: "User Role",
          url: "/master/roles",
          parentKey: "master"
        },
        {
          key: "Currency",
          label: "Currencies",
          url: "/master/currencies",
          parentKey: "master"
        },
        {
          key: "BaseRate",
          label: "Base Rates",
          url: "/master/base-rates",
          parentKey: "master"
        },
        {
          key: "Holiday",
          label: "Holidays",
          url: "/master/holidays",
          parentKey: "master"
        },
        {
          key: "HolidayBatch",
          label: "Holiday Batch",
          url: "/master/holiday-batch",
          parentKey: "master"
        },
        {
          key: "Branch",
          label: "Branch",
          url: "/master/branch",
          parentKey: "master"
        },
        {
          key: "Country",
          label: "Country",
          url: "/master/country",
          parentKey: "master"
        },
        {
          key: "State",
          label: "State",
          url: "/master/state",
          parentKey: "master"
        },
        {
          key: "City",
          label: "City",
          url: "/master/city",
          parentKey: "master"
        },
        {
          key: "RelationshipManagers",
          label: "RelationshipManagers",
          url: "/master/relationshipManagers",
          parentKey: "master"
        },
        {
          key: "LOV",
          label: "LOV",
          url: "/master/lov",
          parentKey: "master"
        },
        {
          key: "ProductType",
          label: "Product Type",
          url: "/master/product-type",
          parentKey: "master"
        },
        {
          key: "GlAccount",
          label: "GL Account",
          url: "/master/glaccount",
          parentKey: "master"
        },
        {
          key: "Co-lender-financer",
          label: "Co-lender Financers",
          url: "/master/co-lender-financiers",
          parentKey: "master"
        }
      ]
    },
    {
      key: "registration",
      label: "Registration",
      isTitle: false,
      icon: "uil-document-layout-center",
      // badge: { variant: 'success', text: '4' },
      children: [
        {
          key: "Customers",
          label: "Customers",
          url: "/registration/customers",
          parentKey: "registration"
        },
        {
          key: "Customer CIC Reporting",
          label: "Customer CIC Reporting",
          url: "/registration/customer-cic-reporting",
          parentKey: "registration"
        },
        {
          key: "LimitConfig",
          label: "Limit Configuration",
          url: "/registration/limit-config",
          parentKey: "registration"
        },
        {
          key: "Programme",
          label: "Programme",
          url: "/registration/programme",
          parentKey: "registration"
        },
        {
          key: "BuyerSeller",
          label: "Buyer Seller",
          url: "/registration/buyer-seller",
          parentKey: "registration"
        }
      ]
    },
    {
      key: "charges",
      label: "Charges",
      isTitle: false,
      icon: "uil-receipt",
      children: [
        {
          key: "receivableChargeList",
          label: "Receivable Charge",
          url: "/charges/receivable-charge",
          parentKey: "charges"
        },
        {
          key: "payableChargesList",
          label: "Payable Charges",
          url: "/charges/payable-charge",
          parentKey: "charges"
        },
        {
          key: "chargeSettlement",
          label: "Charge Settlement",
          url: "/charges/charge-settlement",
          parentKey: "charges"
        }
      ]
    },
    {
      key: "transaction",
      label: "Transaction",
      isTitle: false,
      icon: "uil-clipboard-alt",
      // badge: { variant: 'success', text: '4' },
      children: [
        {
          key: "InstrumentBatch",
          label: "Instrument Batch",
          url: "/transaction/instrument-batch",
          parentKey: "transaction"
        },
        {
          key: "InstrumentBatchUpload",
          label: "Instrument Batch Upload",
          url: "/transaction/instrument-batch-upload",
          parentKey: "transaction"
        },
        {
          key: "Instrument",
          label: "Instrument",
          url: "/transaction/instrument",
          parentKey: "transaction"
        },
        {
          key: "StagingBatch",
          label: "Staging Batch",
          url: "/transaction/staging-batch",
          parentKey: "transaction"
        },
        {
          key: "StagingInstrument",
          label: "Staging Instrument",
          url: "/transaction/staging-instrument",
          parentKey: "transaction"
        },
        {
          key: "PaymentBatch",
          label: "Payment Batch",
          url: "/transaction/payment-batch",
          parentKey: "transaction"
        },
        {
          key: "PaymentInstrument",
          label: "Payment Instrument",
          url: "/transaction/payment-instrument",
          parentKey: "transaction"
        },
        {
          key: "InterestAccrual",
          label: "Daily Interest Accrual",
          url: "/transaction/interest-accrual",
          parentKey: "transaction"
        },
        {
          key: "InstrumentBalancesDailyHistory",
          label: "Instrument Balances Daily History",
          url: "/transaction/instrument-balances-daily-history",
          parentKey: "transaction"
        },
        {
          key: "DailyBalances",
          label: "Instrument Balances",
          url: "/transaction/daily-balances",
          parentKey: "transaction"
        },
        {
          key: "DisbursementAuthorization",
          label: "Disbursement Authorization",
          url: "/transaction/disbursement-authorization",
          parentKey: "transaction"
        }
      ]
    },
    {
      key: "repayment",
      label: "Repayment",
      isTitle: false,
      icon: "uil-chart",
      // badge: { variant: 'success', text: '4' },
      children: [
        {
          key: "repaymentRequest",
          label: "FIFO Settlement",
          url: "/repayment/repayment-request",
          parentKey: "repayment"
        },
        {
          key: "repaymentBulkRequest",
          label: "Instrument wise Settlement",
          url: "/repayment/repayment-intrument-bulk-request",
          parentKey: "repayment"
        },
        {
          key: "excessMoney",
          label: "Excess Money",
          url: "/repayment/excess-money",
          parentKey: "repayment"
        },
        {
          key: "excessMoneySettlement",
          label: "Excess Money Settlement",
          url: "/repayment/excess-money-settlements",
          parentKey: "repayment"
        },
        {
          key: "excessRefund",
          label: "Excess Refund",
          url: "/repayment/excess-refund",
          parentKey: "repayment"
        }
      ]
    },
    {
      key: "reports",
      label: "Reports",
      isTitle: false,
      icon: "uil-file-chart",
      children: [
        {
          key: "DisbursementAdvice",
          label: "Disbursement Advice",
          url: "/report/disbursement-advice/create",
          parentKey: "reports"
        },
        {
          key: "LimitReport",
          label: "Limit Report",
          url: "/report/limit/create",
          parentKey: "reports"
        },
        {
          key: "ClientSummary",
          label: "Client Summary",
          url: "/report/client-summary/create",
          parentKey: "reports"
        },
        {
          key: "InterestComputation",
          label: "Interest Computation",
          url: "/report/interest-computation/create",
          parentKey: "reports"
        },
        {
          key: "RepaymentAdvice",
          label: "Repayment Advice",
          url: "/report/repayment-advice/create",
          parentKey: "reports"
        },
        {
          key: "ProgrammeSummary",
          label: "Programme Summary",
          url: "/report/program-summary/create",
          parentKey: "reports"
        },
        {
          key: "NpaReport",
          label: "NPA Report",
          url: "/report/npa-report/create",
          parentKey: "reports"
        },
        {
          key: "LifeCycleReport",
          label: "Life Cycle Report",
          url: "/report/life-cycle/create",
          parentKey: "reports"
        },
        {
          key: "FundingDetails",
          label: "Funding Details Report",
          url: "/report/funding-details/create",
          parentKey: "reports"
        },
        {
          key: "OverdueReport",
          label: "Overdue Report",
          url: "/report/overdue-report/create",
          parentKey: "reports"
        },
        {
          key: "IntegLogReport",
          label: "Integration Log Report",
          url: "/report/integ-log-report/create",
          parentKey: "reports"
        },
        {
          key: "CrilicReport",
          label: "Crilic Report",
          url: "/report/crilic-report/create",
          parentKey: "reports"
        },
        {
          key: "StatementOfAccounts",
          label: "Statement of Accounts",
          url: "/report/statement-of-accounts/create",
          parentKey: "reports"
        },
        {
          key: "UnrealisedIncomeReport",
          label: "Unrealised Income Report",
          url: "/report/unrealised-income-report/create",
          parentKey: "reports"
        },
        {
          key: "OneViewReport",
          label: "One View Report",
          url: "/report/one-view-report/create",
          parentKey: "reports"
        },
        {
          key: "AmortizationReport",
          label: "Amortization Report",
          url: "/report/amortization-report/create",
          parentKey: "reports"
        },
        {
          key: "BuyerSellerDumpReport",
          label: "BuyerSeller Dump Report",
          url: "/report/buyer-seller-dump-report/create",
          parentKey: "reports"
        },
        {
          key: "ProgrammesDumpReport",
          label: "Programmes Dump Report",
          url: "/report/programmes-dump-report/create",
          parentKey: "reports"
        },

        {
          key: "CustomerDumpReport",
          label: "Customer Dump Report",
          url: "/report/customer-dump-report/create",
          parentKey: "reports"
        },
        {
          key: "ChargeSummaryReport",
          label: "Charge Summary Report",
          url: "/report/charge-summary-report/create",
          parentKey: "reports"
        },
      ]
    },
    {
      key: "system-info",
      label: "System Info",
      isTitle: false,
      icon: "uil-rss",
      // badge: { variant: 'success', text: '4' },
      children: [
        {
          key: "SystemInfo",
          label: "Login Logs",
          url: "/system-info/login-info",
          parentKey: "system-info"
        }
      ]
    }
  ],
  config.DISABLED_MENU
);
export { MENU_ITEMS };
